export type SignInMethod = 'password' | 'google' | 'microsoft' | 'code';

export interface MethodStore {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
}

const KEY = 'partnr.lastSignInMethod';

const METHODS: SignInMethod[] = ['password', 'google', 'microsoft', 'code'];

export function lastSignInMethod(storage: MethodStore | null | undefined): SignInMethod | null {
  try {
    const stored = storage?.getItem(KEY);
    return METHODS.includes(stored as SignInMethod) ? (stored as SignInMethod) : null;
  } catch {
    return null;
  }
}

export function rememberSignInMethod(
  storage: MethodStore | null | undefined,
  method: SignInMethod,
): void {
  try {
    storage?.setItem(KEY, method);
  } catch {
    // A browser refusing storage must not cost the person their sign-in.
  }
}
